import { useContext } from 'react'
import { IconButton, makeStyles } from '@material-ui/core'

import Tooltip from '@material-ui/core/Tooltip'
import HomeIcon from '@material-ui/icons/Home'
import InfoIcon from '@material-ui/icons/Info'
import SettingsIcon from '@material-ui/icons/Settings'
import { useHistory, useLocation } from 'react-router-dom'

import { AppContext } from '../state/Context.tsx'
import { fade } from '@material-ui/core/styles/colorManipulator'

const useStyles = makeStyles((theme) => ({
	root: {
		zIndex: 1,
		position: 'fixed',
		right: 0,
		top: 0,
		textAlign: 'right',
	},
	listRoot: {
		listStyleType: 'none',
		padding: 0,
	},
	[theme.breakpoints.up('sm')]: {
		navItem: {
			borderRadius: `50% 0 0 50%`,
		},
		activeNavItem: {
			background: fade(theme.palette.primary.main, 0.25),
			'&:hover': {
				background: fade(theme.palette.primary.main, 0.35),
			},
		},
	},
	activeNavItem: {
		color: theme.palette.primary.main,
	},
}))

const links = [
	{
		to: '/',
		text: 'Home',
		Icon: HomeIcon,
		match: '(?:/search/(?:basic|advanced))?',
	},
	{
		to: '/instructions',
		text: 'Instructions',
		Icon: InfoIcon,
		match: '/instructions',
	},
	{
		to: '/settings',
		text: 'Settings',
		Icon: SettingsIcon,
		match: '/settings',
	},
]

function MainNav() {
	const classes = useStyles()

	const { dispatch } = useContext(AppContext)

	const location = useLocation()

	const history = useHistory()

	const clearQuery = () =>
		dispatch({
			pendingSearchQuery: '',
			searchQuery: '',
			results: null,
			resultsLoading: false,
		})

	return (
		<nav className={classes.root}>
			<ul className={classes.listRoot}>
				{links.map(({ to, text, Icon, match }, idx) => {
					const path = `${process.env.PUBLIC_URL}${to}`

					const matcher = new RegExp(
						`^${process.env.PUBLIC_URL}${match}/?([?#]|$)`,
					)

					const isMatch = matcher.test(location.pathname)

					return (
						<li key={idx}>
							{/* @ts-ignore TODO: types */}
							<Tooltip placement='left' title={text} arrow>
								<IconButton
									className={isMatch
										? [
											classes.navItem,
											classes.activeNavItem,
										].join(' ')
										: classes.navItem}
									TouchRippleProps={{
										classes: {
											child: classes.touchRippleChild,
										},
									}}
									role='link'
									onClick={() => {
										clearQuery()

										history.push(path)
									}}
									aria-label={text}
								>
									{/* @ts-ignore TODO: types */}
									<Icon />
								</IconButton>
							</Tooltip>
						</li>
					)
				})}
			</ul>
		</nav>
	)
}

export default MainNav
